<template>
  <div class="panel-body">
    <v-card>
      <v-card-title>
        <div class="teal--text display-1 font-weight-bold">{{title}}</div>
      </v-card-title>
      <template>
        <v-container>
          <v-row>
            <v-col cols="4">
              <v-select
                :items="getActions"
                v-if="getActions != null"
                label="Action"
                v-model="selectedAction"
                color="primary"
              />
            </v-col>
                   <v-col cols="4">
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayStartDateTime"
                            label="Start Date"
                            persistent-hint
                            hint="Choose date/time for card incentive to start."
                            class="mr-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearStartDateTime()"
                          />
                        </template>
                        <v-card>
                          <!-- <v-date-picker v-model="displayStartDate" v-on:click:date="startDateMenu = false; startTimeMenu = true"></v-date-picker> -->
                          <v-date-picker v-model="displayStartDate" :min="nowDate" :max="getEndDate">
                          </v-date-picker>
                          <v-time-picker
                            v-model="displayStartTime"
                            format="24hr"
                            @click:minute="startDateMenu = false;setStartDateTime()"
                          >
                          </v-time-picker>
                          <v-spacer></v-spacer>
                          <v-flex class="text-xs-right">
                            <v-btn text color="red" @click="menu = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="menu = false">OK</v-btn>
                          </v-flex>
                        </v-card>
                      </v-menu>
                    </v-col>
                    <v-col cols="4">
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="displayEndDateTime"
                            label="End Date"
                            persistent-hint
                            hint="Choose end date/time for card. If no end date, click 'X' and clear field."
                            class="ml-1"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            clearable
                            @click:clear="clearEndDateTime()"
                          />
                        </template>
                        <v-date-picker v-model="displayEndDate" :min="nowDate" :max="getEndDate">
                        </v-date-picker>
                        <v-time-picker
                          v-model="displayEndTime"
                          format="24hr"
                          @click:minute="endDateMenu = false;setEndDateTime()"
                        />
                      </v-menu>
                    </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
            <v-data-table
                :v-model="incentiveSelected"
                :headers="headers"
                :items="incentives"
                :loading="loadingData"
                item-key="id"
                class="elevation-1"
                :rows-per-page="incRowsPerPage"
                :items-per-page-options="incRppItems"
            >
                <template v-slot:top>
                <v-card-title>Incentive Templates</v-card-title>
                </template>
                <template slot="item" slot-scope="props">
                  <tr @click="activerow(props.item)" :class="{'primary': props.item.id===selectedId}">
                    <td class="text-xs-left" @click="selectIncentive(props.item)">{{ props.item.id }}</td>
                    <td class="text-xs-left" @click="selectIncentive(props.item)">{{ props.item.contests }}</td>
                    <td class="text-xs-left" @click="selectIncentive(props.item)">{{ props.item.amount }}</td>
                    <td class="text-xs-left" @click="selectIncentive(props.item)">{{ props.item.amountAvailable }}</td>
                  </tr>
                </template>
                <template slot="no-data"></template>
                </v-data-table>
            </v-col>
          </v-row>
          <v-layout wrap>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="!this.enableSave()" text @click="save">Save</v-btn>
          </v-layout>
        </v-container>
      </template>
    </v-card>

  </div>
</template>
<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {
  props: {
    card: {
      required: true
    },
    actionIncentive: {
      required: true
    },
    incentiveKey: {
      required: true
    }
  },
  data: () => ({
    incentives: [],
    dialog: false,
    title: 'Add Incentive',
    selectedAction: null,
    selectedIncentive: null,
    localDate: null,
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Contests', value: 'contests' },
      { text: 'Ballots', value: 'amount' },
      { text: 'Max Ballots', value: 'amountAvailable' }
    ],
    displayStartDate: null,
    displayStartTime: null,
    displayStartDateTime: null,
    startDateMenu: null,
    endDateMenu: null,
    displayEndDate: null,
    displayEndTime: null,
    displayEndDateTime: null,
    nowDate: new Date().toISOString().slice(0, 10),
    date: new Date(),
    selectedId: null,
    incentiveSelected: null,
    loadingData: false,
    incRppItems: [
      5,
      10,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    incRowsPerPage: 5,
    initialStartDateTime: null,
    initialEndDateTime: null,
    initialAction: null,
    defaultAddRequest: {
      sourceType: null,
      sourceId: null,
      action: null,
      incentiveTemplateId: null,
      startDate: null,
      endDate: null
    },
    defaultUpdateRequest: {
      id: null,
      sourceType: null,
      sourceId: null,
      action: null,
      incentiveTemplateId: null,
      startDate: null,
      endDate: null
    }
  }),

  created () {
    this.loadIncentives()
  },
  mounted () {
    this.loadIncentives()
  },
  watch: {
    actionIncentive: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadIncentives()
        this.setupEdit()
      }
    }
  },
  computed: {
    getActions () {
      return [ 'TAP', 'COMPLETED' ]
    },
    getEndDate () {
      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 12, 10)
      return endDate.toISOString().slice(0, 10)
    }
  },
  methods: {
    async loadIncentives () {
      this.loadingData = true

      const incentivesEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_INCENTIVE}/incentives`
      var incentivesResponse = await rh.default.get(incentivesEndpoint, true).catch(e => {
        this.errors.push(e)
      })

      if (incentivesResponse === undefined || incentivesResponse.data === '') {
        this.incentives = []
      } else {
        this.incentives = incentivesResponse.data
      }

      var cardId = this.card.id

      const actionIncentivesEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_INCENTIVE}/actionIncentiveTemplates?sourceType=CARD&sourceId=${cardId}`
      var actionIncResponse = await rh.default.get(actionIncentivesEndpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (actionIncResponse === undefined || actionIncResponse.data === '') {
        this.initialCardActionIncentives = []
      } else {
        this.initialCardActionIncentives = actionIncResponse.data
      }
      this.loadingData = false
    },
    setupEdit () {
      if (this.actionIncentive === null) {
        this.title = 'New Card Incentive'
      } else {
        this.title = 'Edit Card Incentive'
      }

      if (this.actionIncentive !== null) {
        this.initialAction = this.actionIncentive.action
        this.initialStartDateTime = this.actionIncentive.startDate
        this.initialEndDateTime = this.actionIncentive.endDate
        this.initialIncentive = this.actionIncentive.incentiveTemplate

        this.selectedAction = this.initialAction
        this.selectedIncentive = this.initialIncentive

        if (this.actionIncentive.startDate !== null) {
          this.displayStartDate = this.formatDate(this.actionIncentive.startDate)
          this.displayStartTime = this.formatTime(this.actionIncentive.startDate)
          this.setStartDateTime()
        } else {
          this.clearStartDateTime()
        }

        if (this.actionIncentive.endDate !== null) {
          this.displayEndDate = this.formatDate(this.actionIncentive.endDate)
          this.displayEndTime = this.formatTime(this.actionIncentive.endDate)
          this.setEndDateTime()
        } else {
          this.clearEndDateTime()
        }
        if (this.initialIncentive !== null) {
          for (var i = 0; i < this.incentives.length; i++) {
            if (this.incentives[i].id === this.initialIncentive.id) {
              this.selectIncentive(this.incentives[i])
              break
            }
          }
        }
      } else {
        this.selectedAction = null
        this.selectedIncentive = null
        this.initialAction = null
        this.initialStartDateTime = null
        this.initialEndDateTime = null
        this.initialIncentive = null
        this.clearEndDateTime()
        this.clearStartDateTime()
        this.selectIncentive(null)
      }
    },
    clearEndDateTime () {
      this.displayEndDate = null
      this.displayEndTime = null
      this.displayEndDateTime = null
    },
    setEndDateTime () {
      var localDate = moment(
        this.displayEndDate + ' ' + this.displayEndTime
      )
      this.displayEndDate = this.formatDate(localDate)
      this.displayEndTime = this.formatTime(localDate)
      this.displayEndDateTime = this.formatDateTime(localDate)
    },
    clearStartDateTime () {
      this.displayStartDate = null
      this.displayStartTime = null
      this.displayStartDateTime = null
    },
    setStartDateTime () {
      this.localDate = moment(
        this.displayStartDate + ' ' + this.displayStartTime
      )
      this.displayStartDate = this.formatDate(this.localDate)
      this.displayStartTime = this.formatTime(this.localDate)
      this.displayStartDateTime = this.formatDateTime(this.localDate)
    },
    close () {
      this.dialog = false
      this.$emit('close-card-incentive')
    },
    async save () {
      const editAddEndpoint = `${process.env.VUE_APP_QUBER_SERVICE_INCENTIVE}/actionIncentiveTemplates`
      var actionIncResponse
      var actIncentive = this.createActionIncentive()
      if (this.actionIncentive !== null) {
        actionIncResponse = await rh.default.put(editAddEndpoint, actIncentive, true).catch(e => {
          this.errors.push(e)
        })
      } else {
        actionIncResponse = await rh.default.post(editAddEndpoint, actIncentive, true).catch(e => {
          this.errors.push(e)
        })
      }

      this.dialog = false
      this.$emit('save-card-incentive')
    },
    createActionIncentive () {
      var actInc
      if (this.actionIncentive !== null) {
        actInc = JSON.parse(JSON.stringify(this.defaultUpdateRequest))
        actInc.id = this.actionIncentive.id
        actInc.sourceType = 'CARD'
        actInc.sourceId = this.card.id
        actInc.action = this.selectedAction
        actInc.startDate = this.formattedDate(this.displayStartDate, this.displayStartTime)
        actInc.endDate = this.formattedDate(this.displayEndDate, this.displayEndTime)
        actInc.incentiveTemplateId = this.selectedIncentive.id
      } else {
        actInc = JSON.parse(JSON.stringify(this.defaultAddRequest))
        actInc.sourceType = 'CARD'
        actInc.sourceId = this.card.id
        actInc.action = this.selectedAction
        actInc.startDate = this.formattedDate(this.displayStartDate, this.displayStartTime)
        actInc.endDate = this.formattedDate(this.displayEndDate, this.displayEndTime)
        actInc.incentiveTemplateId = this.selectedIncentive.id
      }
      return actInc
    },
    formattedDate (datePart, timePart) {
      if (datePart === null || timePart === null) {
        return null
      }
      return datePart + 'T' + timePart
    },
    revert () {
      this.editMessages = JSON.parse(JSON.stringify(this.messages))
      this.setupEdit()
    },
    open () {

    },
    selectIncentive (incentive) {
      this.selectedIncentive = incentive
      this.activerow(incentive)
    },
    enableSave () {
      return true
    },
    activerow (item) {
      this.selectedId = item.id
      this.$set(item, 'selected', true)
    },
    formatDate (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD')
    },
    formatTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('HH:mm')
    },
    formatDateTime (aDate) {
      if (!aDate) return null
      return moment(String(aDate)).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>
